import { render } from "./ParentsInput.vue?vue&type=template&id=4bf5945e&scoped=true"
import script from "./ParentsInput.vue?vue&type=script&lang=js"
export * from "./ParentsInput.vue?vue&type=script&lang=js"

import "./ParentsInput.vue?vue&type=style&index=0&id=4bf5945e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf5945e"]])

export default __exports__